export default __webpack_public_path__ + "static/media/inn-edit-product.c286d500.png";